// Ends the hold in a page transition (_page-transition.scss). The old page's field and
// portrait images stay on top of the new page's until the new ones have drawn. The hold's
// keyframes swap them in their last `GIVE_WAY_MS`, and this skips the images ahead to there.

/** The swap: the last 5% of the hold (`$hold`, 3s, in _page-transition.scss). */
const GIVE_WAY_MS = 150;
const HELD = /^::view-transition-(old|new)\((field|portrait)\)$/;
// The transition's images only exist from its first frame, which can come after the parts
// have drawn (say, a part that fails right away), so keep looking for a few frames.
const SEARCH_FRAMES = 10;

/** Let the old field and portrait images give way to the new ones, if a page transition
    holds them. */
export function handOffSharedParts(frames = SEARCH_FRAMES): void {
  const held = document.getAnimations().filter((animation) => {
    const effect = animation.effect;
    return effect instanceof KeyframeEffect && HELD.test(effect.pseudoElement ?? "");
  });
  if (held.length === 0) {
    if (frames > 0) requestAnimationFrame(() => handOffSharedParts(frames - 1));
    return;
  }
  for (const animation of held) {
    const end = animation.effect?.getComputedTiming().endTime;
    if (typeof end !== "number") continue;
    const swap = end - GIVE_WAY_MS;
    if (Number(animation.currentTime ?? 0) < swap) animation.currentTime = swap;
  }
}
